import { useSessionStorage } from '@commenda/kakashi';
import { useState } from 'react';

// Read after mount, not during render, because the composer server-renders.
const DRAFT_STORAGE_OPTIONS = { initializeWithValue: false };

// Keeps the composer's unsent text in sessionStorage so it survives the
// composer unmounting (switching threads or pages). A `null` key (chat room
// not loaded yet) keeps the draft in memory only.
export function useChatDraft(
  inputDraftStorageKey: string | null,
  initialContent = ''
) {
  const [inMemoryDraft, setInMemoryDraft] = useState<string | null>(null);
  const [storedDraft, setStoredDraft] = useSessionStorage<string | null>(
    inputDraftStorageKey ?? '',
    null,
    DRAFT_STORAGE_OPTIONS
  );

  const isPersisted = inputDraftStorageKey !== null;
  const draft = isPersisted ? storedDraft : inMemoryDraft;

  return {
    content: draft ?? initialContent,
    setContent: isPersisted ? setStoredDraft : setInMemoryDraft,
  };
}
